import { render, staticRenderFns } from "./IDCard.vue?vue&type=template&id=d8edf7cc&"
import script from "./IDCard.vue?vue&type=script&lang=ts&"
export * from "./IDCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports